
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { inject } from '@angular/core';
import { map } from 'rxjs';

export const B2BDashboardGuard: CanActivateFn = (route, state) => {
    const store = inject(Store)
    const router = inject(Router)
    return store.select('auth').pipe(
        map(authRes => {
            const user = authRes.user;
            switch (user?.type) {
                case 5:
                    return true;
                default:
                    router.navigate(['/'])
                    return false;
            }
        })
    )
}
